import {
   AppointmentSlotScheduleFreeSlot,
   AppointmentSlotScheduleFreeSlotQuery,
} from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { CqrsQueryPerformResult, performCqrsQueryFindFirst } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { Range } from '@dreryk/watermelon';

import { AppointmentHoverSlotData } from '~libs.shared.appointments-timetable';

const TWO_HUNDRED_DAYS_IN_MS = 17280000000;

export const getNextAvailableTimeSlot = (
   slots: AppointmentHoverSlotData[] | undefined,
   currentAvailableTimeSlot: AppointmentHoverSlotData | undefined
): AppointmentHoverSlotData | undefined => {
   const currentTime = Date.now();
   return slots?.find((slot) => {
      return (
         slot.timeSlot.getBeginDate().getTime() >
            (currentAvailableTimeSlot?.timeSlot.getBeginDate().getTime() ?? currentTime) &&
         slot.timeSlot.getEndDate().getTime() >
            (currentAvailableTimeSlot?.timeSlot.getEndDate().getTime() ?? currentTime)
      );
   });
};

export const findNextAppointmentSlotScheduleFreeSlot = async (
   selectedPractitionerId: PractitionerId,
   dateFrom: Date
): CqrsQueryPerformResult<AppointmentHoverSlotData | null> => {
   return performCqrsQueryFindFirst<AppointmentSlotScheduleFreeSlot>(() => {
      const query = new AppointmentSlotScheduleFreeSlotQuery();
      query.practitionerId = selectedPractitionerId;
      const dateTo = new Date(Number(dateFrom) + TWO_HUNDRED_DAYS_IN_MS);
      query.dateRange = Range.openClosed(dateFrom, dateTo);
      return query;
   }, paginations.first());
};
